import { useQuery } from "@tanstack/react-query";

import { srvProceedingApi } from "@/api";
import { QueryKey } from "@/query/Query";

/** The client's Verfahren for the navigation, most recently created first. */
export function useSrvProceedings(clientId: string) {
  const { data } = useQuery({
    queryKey: [QueryKey.SrvProceeding, clientId],
    queryFn: () => srvProceedingApi.getSrvProceedings({ clientId }),
    meta: { loadingScope: "pageContent" },
  });

  return { proceedings: data };
}
